export const productStatus = [
  {
    key: "available",
    value: "Hiện có",
  },
  {
    key: "out_of_stock",
    value: "Hết hàng",
  },
  {
    key: "discontinued",
    value: "Ngưng kinh doanh",
  },
];

export const productMadeBy = [
  {
    key: "KATEC",
    value: "Sản phẩm của Katec",
  },
  {
    key: "OTHER",
    value: "Sản phẩm cty khác",
  },
];
